<template>
  <div class="ob" :class="{ 'is-busy': !!loader }">
    <header class="ob-top">
      <span class="ob-mark">Smartbooks</span>
    </header>
    <main class="ob-main">
      <p class="ob-kicker">Email</p>
      <h1 class="ob-title">{{ verified ? "You’re in." : "Tap the link." }}</h1>
      <p class="ob-lead">
        {{
          verified
            ? "The book is waiting."
            : "Open the newest Smartbooks email, then come back here."
        }}
      </p>
      <p v-if="error" class="ob-error">{{ error }}</p>
      <div class="ob-stack">
        <router-link v-if="verified" class="ob-primary" tag="button" to="/start">
          Open the book
        </router-link>
        <button v-else class="ob-primary" type="button" @click="submit">
          Send it again
        </button>
      </div>
    </main>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { errorMessage } from "@/helpers/bookingSearch";
import { captureVerifyToken } from "@/helpers/onboard";

export default {
  data() {
    return {
      loader: null,
      verified: false,
      error: ""
    };
  },
  methods: {
    ...mapActions(["sendVerificationEmail", "verifyUser"]),
    goOnward() {
      if (this.isAuthenticated) {
        this.$router.replace("/start");
        return;
      }
      this.$router.replace({ path: "/auth/login", query: { next_url: "/start" } });
    },
    async submit() {
      try {
        await this.sendVerificationEmail();
        this.$notify({
          type: "success",
          text: this.$t("message.sendVerificationEmailSuccess")
        });
      } catch (error) {
        this.error = errorMessage(error, "Could not send the email.");
      }
    }
  },
  computed: mapGetters(["isAuthenticated", "isVerified"]),
  async created() {
    const token = captureVerifyToken(this.$route);

    if (this.isVerified) {
      this.verified = true;
      this.goOnward();
      return;
    }

    if (!token) {
      this.goOnward();
      return;
    }

    this.loader = true;
    try {
      const response = await this.verifyUser({ token });
      if (response && response.data && response.data.success) {
        this.verified = true;
        this.goOnward();
        return;
      }
      throw new Error(
        (response && response.data && response.data.message) ||
          "Could not confirm that email."
      );
    } catch (error) {
      this.error = errorMessage(error, "Could not confirm that email.");
      this.goOnward();
    } finally {
      this.loader = null;
    }
  }
};
</script>
